import React from 'react'
import { Subheading } from '../HeadingModule/Subheading'
import '../../styles/DisclosureModule/DisclosureSubheading.scss'

export interface DisclosureSubheadingProps {
  subheading: string
  fallback: string
}

export const DisclosureSubheading = ({ subheading, fallback }: DisclosureSubheadingProps) => {
  return <Subheading text={subheading || fallback} className="disclosure-subheading" />
}
